/*
 * @Description: 支付网关
 * @Author: gao shuai
 * @Date: 2020-02-25 15:36:33
 * @LastEditTime: 2020-04-21 16:28:55
 * @LastEditors: gao shuai
 */
import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  /* ---------------------1.通道管理------------------------- */
  // 通道列表
  async throughlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/GetGalleryPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加通道选项
  async throughset(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/GetGalleryProductList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加通道
  async addthrough(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/AddGallery',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加通道
  async deletethrough(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/DeleteGallery',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加通道
  async switchstate(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/ChangeState',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 通道信息
  async throughinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/GetGalleryDetail',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 通道更新
  async throughupdate(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/UpdateGallery',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 通道费率信息
  async rateinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/GetGalleryRates',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 通道费率更新
  async rateupdate(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/UpdateGalleryRates',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 绑定分账信息列表
  async throughbindinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/GetGalleryBindList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 添加绑定信息
  async bindadd(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/AddGalleryBind',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 编辑绑定信息
  async bindedit(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/EditGalleryBind',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ---------------------2.产品管理------------------------- */
  // 产品列表
  async productlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/GetProductPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 一键切换网银通道
  async netdrow(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/GetGalleries',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 删除产品
  async delproduct(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/DeleteProduct',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 更改状态
  async stateproduct(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/ChangeState',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取产品详情
  async productinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/GetProduct',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取产品类型列表
  async producttype(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/GetManagerProductTypes',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取产品通道列表
  async productthrough(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGallery/GetGalleriesByTypeMark',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 产品更新
  async proupdate(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/UpdateProduct',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 产品添加
  async proadd(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/AddProduct',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 列表的排序
  async prosort(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageProduct/UpdateProductSort',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }

};
